<script>
import BaseModal from '../BaseModal';
import Modal from '../../mixins/Modal';

export default {
  name: 'AuthModal',
  components: { BaseModal },
  mixins: [Modal],
  props: {
    callback: {
      type: Function,
      required: true,
    },
    iframeUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      iframeHeight: null,
    };
  },
  computed: {
    iframeStyles() {
      return {
        height: `${this.iframeHeight}px`,
      };
    },
    isModalActive: {
      /**
       * @returns {boolean}
       */
      get() {
        return window.modalStateObservable.isAuthModalActive;
      },
      /**
       * @param {boolean} value
       */
      set(value) {
        window.modalStateObservable.isAuthModalActive = value;
      },
    },
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage, false);
  },
  methods: {
    /**
     * @param {string} origin
     * @param {object} data
     */
    receiveMessage({ origin, data }) {
      if (origin !== window.location.origin) {
        return;
      }

      if (data.auth) {
        this.isModalActive = false;
        this.callback();
      }

      if (data.height) {
        this.iframeHeight = data.height;
      }
    },
  },
};
</script>

<template>
  <BaseModal v-model="isModalActive" class="auth-modal" white>
    <template v-slot:header-content>
      {{ title }}
    </template>

    <iframe
      :src="iframeUrl"
      class="auth-modal__iframe"
      :style="iframeStyles"
    ></iframe>
  </BaseModal>
</template>

<style scoped lang="scss">
.auth-modal {
  &__iframe {
    width: 100%;
    border: 0;
    transition: height $default-transition-duration;
  }

  &::v-deep .base-modal {
    &__container {
      width: 48em;
    }

    &__header {
      color: $color-white;
    }

    &__body-container {
      padding: 0;
    }
  }
}
</style>
